export default "__VITE_ASSET__D2j3xKNw__"